import { Dispatch } from 'react';
import { toast } from 'react-toastify';
import { transformDateFormat } from 'susy-common/date-utils';
import { SuSyApi } from '../../api/susyApi';
import { IAdminDocument } from '../../components/admin/supervisors/interfaces';
import {
    AdminDocumentAction,
    AdminDocumentActionType,
} from '../actionTypes/adminDocument';
import {
    ADD_ADMIN_DASHBOARD_PROJECT,
    REMOVE_ADMIN_DASHBOARD_PROJECT,
} from './types';
import { PostDispatch, ProjectBrowserModel } from '../types';

export const createAdminDocument =
    (adminDocument: IAdminDocument, file: File | null) =>
    async (dispatch: Dispatch<AdminDocumentAction>) => {
        if (!file) {
            toast.warning('File must be uploaded');
            return; //Show error?
        }

        const formData = new FormData();

        formData.append('adminDocumentDocuments', file, file.name);
        formData.append('adminDocumentJSON', JSON.stringify(adminDocument));

        const response = await SuSyApi.post(`/adminDocument`, formData);

        dispatch({
            type: AdminDocumentActionType.CREATE_ADMIN_DOCUMENT,
            payload: response.data,
        });
    };

export const getAllAdminDocuments =
    () => async (dispatch: Dispatch<AdminDocumentAction>) => {
        const { data } = await SuSyApi.get(`/adminDocument`);
        dispatch({
            type: AdminDocumentActionType.GET_ALL_ADMIN_DOCUMENTS,
            payload: data,
        });
    };

export const deleteAdminDocument =
    (adminDocumentId: string | undefined) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        if (!adminDocumentId) {
            return;
        }

        await SuSyApi.delete(`/adminDocument/${adminDocumentId}`);

        dispatch({
            type: AdminDocumentActionType.DELETE_ADMIN_DOCUMENT,
            payload: { adminDocumentId },
        });
    };

export const updateAdminDocument =
    (adminDocument: IAdminDocument, file: File | null) =>
    async (dispatch: Dispatch<AdminDocumentAction>) => {
        const formData = new FormData();

        if (file) {
            formData.append('adminDocumentDocuments', file, file.name);
        }

        formData.append('adminDocumentJSON', JSON.stringify(adminDocument));

        const response = await SuSyApi.put(
            `/adminDocument/${adminDocument._id}`,
            formData
        );
        dispatch({
            type: AdminDocumentActionType.UPDATE_ADMIN_DOCUMENT,
            payload: response.data,
        });
    };

export const getAdminDocumentsByUserRole =
    () => async (dispatch: Dispatch<AdminDocumentAction>) => {
        const { data } = await SuSyApi.get(`/adminDocument/byRole`);
        dispatch({
            type: AdminDocumentActionType.GET_ADMIN_DOCUMENTS_BY_ROLE,
            payload: data,
        });
    };

export const getLayerAdminDocuments =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const { data } = await SuSyApi.get(`/adminDocument/layer`);
        dispatch({
            type: AdminDocumentActionType.GET_LAYER_ADMIN_DOCUMENTS,
            payload: data,
        });
    };

export const addAdminDashboardProject = (project: ProjectBrowserModel) => ({
    type: ADD_ADMIN_DASHBOARD_PROJECT,
    payload: transformDateFormat(project),
});

export const removeAdminDashboardProject = (projectId: string | null) => ({
    type: REMOVE_ADMIN_DASHBOARD_PROJECT,
    payload: { projectId },
});
